import { Decimal } from 'decimal.js'

/**
 * Safe function to get a Decimal value
 * @param {number|string|Decimal} value The value to be parsed
 * @param {number|string|Decimal} [defaultValue] The default value to be returned on error
 */
const getDecimalValue = (value, defaultValue = 0) => {
  let decimalValue
  try {
    decimalValue = new Decimal(value)
    if (decimalValue.isNaN() || !decimalValue.isFinite()) {
      throw new Error('Value cannot be NaN or Infinite')
    }
  } catch (err) {
    decimalValue = defaultValue !== null ? new Decimal(defaultValue) : null
  }
  return decimalValue
}

export default getDecimalValue
